<template>
  <div style="padding: 20px 10px 10px 10px; background: #f7f8fa; height: 100vh">
    <van-search
      style="box-shadow: 0px 0px 10px rgba(128, 128, 128, 0.2)"
      v-model="value"
      @search="onSearch"
      placeholder="请输入搜索关键词"
    />
    <div
      style="margin: 10px 0; box-shadow: 0px 0px 10px rgba(128, 128, 128, 0.2)"
    >
      <van-notice-bar
        left-icon="volume-o"
        background="#ffffff"
        color="#000"
        :text="form.notice"
      />
    </div>
    <div
      style="
        margin-top: 10px;
        background-color: #fff;
        box-shadow: 0px 0px 10px rgba(128, 128, 128, 0.2);
      "
    >
      <div
        style="
          line-height: 40px;
          font-size: 17px;
          font-weight: 700;
          padding-bottom: 10px;
          border-bottom: 1px solid #c9c9c9;
        "
      >
        <span style="color: #c9c9c9">——</span>
        {{ form.name }}
        <span style="color: #c9c9c9">——</span>
      </div>
      <div style="padding-bottom: 20px">
        <van-row type="flex" style="padding: 10px" justify="space-around">
          <van-col
            style="
              border-radius: 8px;
              margin-top: 10px;
              box-shadow: 0px 0px 10px rgba(128, 128, 128, 0.2);
            "
            v-for="item in list"
            :key="item.id"
            span="10"
            @click="url(item)"
          >
            <div style="padding: 5px 10px; display: flex">
              <div v-html="item.icon"></div>

              <div
                style="
                  width: 80%;
                  line-height: 30px;
                  text-align: center;
                  margin-left: 10px;
                  font-size: 16px;
                "
              >
                {{ item.menuName }}
              </div>
            </div>
          </van-col>
          <van-col span="10"></van-col>
        </van-row>
      </div>
    </div>
    <div style="width: 100%; margin: 10px 0">
      <img
        v-for="item in img"
        :key="item.id"
        style="width: 100%"
        :src="item.image"
        alt=""
        @click="imgUrl(item.menuUrl)"
      />
    </div>
    <div style="padding: 10px; color: #777777">
      {{ form.foot }}
    </div>
  </div>
</template>

<script>
  import { Loading } from "element-ui";
  import { mapActions } from "vuex";
  import { guideOneList, guideInfo } from "@/api/cardOperation";
  export default {
    data() {
      return {
        form: {},
        value: "",
        list: [],
        img: [],
        di: [],
      };
    },
    created() {
      this.getAll();
      Loading.service();
    },
    mounted() {
      this.nmae();
    },
    methods: {
      ...mapActions(["getAll"]),
      onSearch() {
        this.list = [];
        guideOneList({
          guideId: this.form.id,
          menuName: this.value,
          menuType: "",
        }).then((res) => {
          if (res.status) {
            res.data.forEach((item) => {
              if (item.state == true) {
                if (item.menuType == 0 || item.menuType == 1) {
                  item.array = item.icon.split("<svg");
                  item.icon =
                    "<svg style='width: 30px; height: 30px'" + item.array[1];
                  this.list.push(item);
                }
              }
            });
          } else {
            this.$notify({ type: "warning", message: res.msg });
          }
        });
      },
      //引导页名称
      nmae() {
        guideInfo(this.$route.params.id).then((res) => {
          if (res.status) {
            this.form = res.data;
            if (this.form.alert != "") {
              this.$dialog
                .alert({
                  title: "提示",
                  message: this.form.alert,
                })
                .then(() => {
                  // on close
                });
            }
            this.guideOneList();
          } else {
            this.$notify({ type: "warning", message: res.msg });
          }
        });
      },
      //跳转二级
      url(val) {
        if (val.menuType == 0) {
          if (val.alert == "" || val.alert == undefined) {
            this.$router.push(`/guide2/${val.id}/${this.$route.params.id}`);
          } else {
            this.$dialog
              .confirm({
                title: "提示",
                message: val.alert,
              })
              .then(() => {
                this.$router.push(`/guide2/${val.id}/${this.$route.params.id}`);
              })
              .catch(() => {
                // on cancel
              });
          }
        } else {
          if (val.alert == "" || val.alert == undefined) {
            window.location.href = val.menuUrl;
          } else {
            this.$dialog
              .confirm({
                title: "提示",
                message: val.alert,
              })
              .then(() => {
                window.location.href = val.menuUrl;
              })
              .catch(() => {
                // on cancel
              });
          }
        }
      },
      //图片跳转
      imgUrl(val) {
        if (val == "") {
          console.log(val);
        } else {
          window.location.href = val;
        }
      },
      //获取一级列表
      guideOneList() {
        this.list = [];
        this.img = [];
        this.di = [];
        guideOneList({
          guideId: this.form.id,
          menuName: this.value,
          menuType: "",
        }).then((res) => {
          if (res.status) {
            res.data.forEach((item) => {
              if (item.state == true) {
                if (item.menuType == 0 || item.menuType == 1) {
                  item.array = item.icon.split("<svg");
                  item.icon =
                    "<svg style='width: 30px; height: 30px'" + item.array[1];
                  this.list.push(item);
                } else {
                  this.img.push(item);
                }
              }
            });
            Loading.service().close();
          } else {
            this.$notify({ type: "warning", message: res.msg });
          }
        });
      },
    },
  };
</script>

<style></style>
